// extracted by mini-css-extract-plugin
export var dividerContainer = "_7p-0";
export var line = "_7p-1";